import * as React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import localforage from 'localforage';
import { IWidgetGraph } from '../../OnlinePanel/OnlinePanelState';
import { URL_EV_BATTERY_KW, URL_GRAPHS } from '../../../router/constants';
import { evBatteryKwWidgetGraphAtom, isGraphOpenAtom } from '../../Graphs/GraphState';
import useAnalytics from '../../../hooks/useAnalytics';
import EvBatteryOnline from '../../Graphs/EvBatteryKw';

export default function EvBatteryWidgetGraph(props: { vehicleId: number }): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const [evBatteryWidgetGraph, setEvBatteryWidgetGraph] = useRecoilState<IWidgetGraph | null>(
    evBatteryKwWidgetGraphAtom
  );
  const setIsGraphOpen = useSetRecoilState<boolean | number>(isGraphOpenAtom);

  const closeWidgetGraph = (event: React.MouseEvent<HTMLAnchorElement>) => {
    trackEvent(['EvBatteryKw Widget', 'click', 'Close widget graph']);
    event.preventDefault();
    setEvBatteryWidgetGraph(null);
    localforage.setItem('widgetGraph', null);
    setIsGraphOpen(false);
  };

  const openEvBatteryKwPage = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    trackEvent(['EvBatteryKw Widget', 'click', 'Open EvBatteryKw page to new window']);
    window.open(`${URL_GRAPHS}${URL_EV_BATTERY_KW}/${evBatteryWidgetGraph?.vehicleId}`, '_blank');
  };

  const getDate = () => {
    if (evBatteryWidgetGraph && evBatteryWidgetGraph.timestamp) {
      return dayjs(evBatteryWidgetGraph.timestamp).format('DD.MM.YYYY');
    }
    return '';
  };

  React.useEffect(() => {
    trackEvent(['EvBatteryKw Widget', 'show', 'Widget graph']);
    return () => {
      if (evBatteryWidgetGraph && evBatteryWidgetGraph.timestamp !== undefined) {
        setEvBatteryWidgetGraph(null);
        localforage.setItem('widgetGraph', null);
        trackEvent(['EvBatteryKw Widget', 'close', 'Widget graph']);
        setIsGraphOpen(false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ background: '#fff', borderRadius: '4px', margin: '2px', width: '756px' }}>
      <div
        style={{
          padding: '10px 14px 10px 10px',
        }}
      >
        <div className="">
          <div style={{ display: 'inline-flex' }}>
            <a
              href=""
              onClick={closeWidgetGraph}
              className="cmd-icon cmd-icon-arrow-left-ext"
              title={f({ id: 'graph.onlinepanel.back' })}
              style={{
                color: '#494949',
                marginRight: '12px',
                top: '2px',
                position: 'relative',
              }}
            />
            {`${f({ id: 'enum.onlineMap.widget.types.evBattery' }) } (kWh)`}: {getDate()}
          </div>
          <div
            style={{
              float: 'right',
              padding: '2px 10px',
              textAlign: 'center',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            className="e-button--gray mb-2"
            onClick={openEvBatteryKwPage}
          >
            {f({ id: 'table.detailBtn' })}
          </div>
        </div>
      </div>
      <div style={{ padding: '0 0 0 10px' }}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <EvBatteryOnline vehicleId={props.vehicleId} />
        </React.Suspense>
      </div>
    </div>
  );
}
